import moment from 'moment';

export const setDownloadHistory = (data) => {
  // 기존 히스토리 배열 가져오기
  let history = JSON.parse(localStorage.getItem('history')) || [];

  // 현재 시간 생성
  const currentDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  
  // 데이터 가공
  const dateRange = data.dateRange.map((item) => moment(item).format('YYYY-MM-DD HH:mm:ss'));

  // 새로운 항목 생성
  const newItem = { clickDate: currentDate, dateRange: dateRange, jobId: data.job_id};

  // 히스토리에 새 항목 추가
  history.unshift(newItem);

  // 배열 길이를 3으로 제한
  history = history.slice(0, 3);

  // 로컬 스토리지에 저장
  localStorage.setItem('history', JSON.stringify(history));
}

export const convertDownloadHistoryData = (data) => {
  let result = [];
  if (data) {
    let dataArray = data;
    dataArray.map((item) => {
      const jsonDateRange = JSON.parse(item.history_json);
      const dateRange = [];
      dateRange.push(moment(jsonDateRange.search_date_start).format('YYYY-MM-DD HH:mm:ss'));
      dateRange.push(moment(jsonDateRange.search_date_end).format('YYYY-MM-DD HH:mm:ss'));
  
      result.push({
        job_id : item.job_id,
        download_at: moment(item.download_at).format('YYYY-MM-DD HH:mm:ss'),
        dateRange: dateRange,
        status: item.status_message
      });
    });
  }

  return result;
}